import { Accordion, AccordionDetails, AccordionSummary, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { CancelIcon, ClioIcon, CsvColorIcon, ExcelColorIcon, ExpandMore, HubSpotIcon, MicroSoftImportContacts, MicrosoftImportContactsBlueTick } from "../../../icon";
import { ColDef, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import * as selector from '../../../selectors/selectors';
import { useSelector } from "react-redux";
import { SingleImportContactsResponse, SingleMaptoImportContactsReportResponse } from "../../../models/conversations";
import { ContactService } from "../../../services/ContactService";
import { UtilityService } from "../../../services/UtilityService";
import GridComponent from "../../shared/grid";
import { AvatarRenderer } from "../../shared/grid/avatarRenderer";
import AnimateLoader from "../../shared/loaders/animate-loader.component";
import ImportReportLoader from "../../shared/loaders/Import-report-loader.json"
import { BulkImportReportModel, ImportType } from "../../../models/reports.model";
import { MessageService } from "../../../services/MessageService";
import { BulkImportReport, ImportReportResponse, MaptoBulkImportReport } from "../../../models/conversations/schedule-messages.model";
import { customStringComparator } from "../../../helpers/custom-comparators";
import { MessageTagRenderer } from "../../shared/grid/msgTagRendrer";

type Props = {
    Open: boolean;
    HandleClose: () => void;
    Contact?: ImportReportResponse;
    Source?: string;
    Data?: BulkImportReportModel
}

function ContactHistoryInfo({ Open, HandleClose, Contact, Source, Data }: Props) {

    const [expanded, setExpanded] = useState<string | false>(false);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [recards, setRecords] = useState<SingleImportContactsResponse>()
    const [gridApi, setGridApi] = useState<any>();
    const [columnApi, SetColumnApi] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [scheduleReport, setScheduleReport] = useState<BulkImportReport>()

    const getGridData = () => {
        setLoading(true)
        ContactService.getContactImportReportById(Contact.Id).then(res => {
            setRecords(SingleMaptoImportContactsReportResponse(res.data))
            setLoading(false)
        }).catch(err => {
            console.log("err:", err)
        })
    }

    useEffect(() => {
        if (Data.Type === ImportType.Contacts && Contact?.Id) {
            getGridData()
        } else if (Data.Type === ImportType.ScheduledMessages) {
            setLoading(true)
            MessageService.getScheduleReportById(Data.ReportId ? Data.ReportId : Data.Source).then((res) => {
                console.log(res.data)
                setScheduleReport(MaptoBulkImportReport(res.data))
                setLoading(false)
            }).catch((err) => {
                console.log(err)
                setLoading(false)
            })
        } else {
            setLoading(true)
            ContactService.getLatestContactsImportReports(Source).then(res => {
                setRecords(SingleMaptoImportContactsReportResponse(res.data))
                setLoading(false)
            })
        }
    }, [])


    const handleChangeAccordion = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const ContactsColoumnDefs: ColDef[] = [
        {
            field: "firstName",
            headerName: "Name",
            valueGetter: (params: ValueGetterParams) => {
                return IsMobileDevice ? params.data.LastName ? UtilityService.trimMessage(`${params.data.FirstName} ${params.data.LastName}`, 30)
                    : `${params.data.FirstName}`
                    : `${params.data.FirstName} ${params.data.LastName ? params.data.LastName : ""}`
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                const AvatarComponent = {
                    component: AvatarRenderer,
                    params: {
                        SetName: params.data.FirstName + " " + params.data.LastName,
                        ShowBadgeIcon: false,
                        HideAvatar: IsMobileDevice,
                        PhoneNumber: params.data.PhoneNumber,
                    }
                }
                if (params.data) {
                    return AvatarComponent
                }

                return undefined
            },
            resizable: true,
            autoHeight: IsMobileDevice ? true : false,
            minWidth: IsMobileDevice ? null : 200,
        },
        {
            field: "email",
            headerName: "Email",
            valueGetter: (params: ValueGetterParams) => {
                return `${!!params.data.Email ? params.data.Email : " --"}`
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                return undefined
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 180,
        },
        {
            field: "phoneNumber	",
            headerName: "Phone Number",
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.PhoneNumber}`
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                return undefined
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 180,
        },
        {
            field: "Errors",
            headerName: "Errors",
            cellRenderer: (params) => <div>
                {
                    params.data.Errors &&
                        Object.keys(params.data.Errors).length > 0
                        ? Object.entries(params.data.Errors as Record<string, string>).map(([key, value]) => (
                            <div key={key}>
                                <strong>{key}</strong> :{" "}
                                <span className="d-flex w-break">
                                    {value}
                                </span>
                            </div>
                        ))
                        : "--"
                }
            </div>,
            autoHeight: true,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200,
        },
    ]

    const ScheduleColoumnDefs: ColDef[] = [
        {
            field: "ContactNumber",
            headerName: "To",
            valueGetter: (params: ValueGetterParams) => {
                return IsMobileDevice ? params.data.ContactNumber : params.data.ContactNumber
            },
            resizable: true,
            autoHeight: true,
            minWidth: 145,
        },
        {
            field: "Type",
            headerName: "Type",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Type
            },
            maxWidth: 100
        },
        {
            field: "Message",
            headerName: "Message",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Message
            },
            comparator: customStringComparator,
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const Message = {
                        component: MessageTagRenderer,
                        params: {
                            Message: params.data.Message ? params.data.Message : "", ShowMediaIcon: !!params.data?.Media?.length
                        }
                    }
                    return Message;
                }
                return undefined
            },
            autoHeight: true,
        },
        {
            field: "ScheduleDateTime",
            headerName: "Schedule Date Time",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.ScheduleDateTime
            },
        },
        {
            field: "Errors",
            headerName: "Errors",
            cellRenderer: (params) => <div>
                {Object.keys(params.data.Errors)?.length > 0 ? Object.entries(params.data.Errors as Record<string, string>).map(([key, value]) => (
                    <div key={key}>
                        <strong>{key}</strong> : <span className="d-flex w-break" >{value}</span>
                    </div>
                )) : "--"}
            </div>,
            autoHeight: true,
            resizable: true,
            hide: false,
            minWidth: 180,
        },

    ]

    const GridReady = (params: any): void => {
        setGridApi(params.api)
        SetColumnApi(params.columnApi)
    }

    const getPanelData = (panel: string, recards: SingleImportContactsResponse | BulkImportReport | undefined) => {
        switch (panel) {
            case 'panel1':
                return recards?.SavedRecords;
            case 'panel2':
                return recards?.IgnoredRecords;
            case 'panel3':
                return recards?.ExistingRecords;
            default:
                return [];
        }
    }

    return (
        <Dialog
            open={Open}
            onClose={HandleClose}
            classes={{
                paper: "br-2 dialogue-shadow w-100 bg-color-menu-bg"
            }}
            maxWidth={"lg"}
        >
            <DialogTitle id="responsive-dialog-title" className='d-flex justify-flex-end p-2' classes={{ root: "pb-0" }}><CancelIcon onClick={HandleClose} className=" c-pointer" /></DialogTitle>

            <DialogContent className="p-2">
                <div className="d-flex justify-center">
                    {(Source === "File" || Source === "XLSX") ? <ExcelColorIcon className='w-10 h-8 mr-2' /> : Source === "HubSpot" ? <HubSpotIcon /> : Source === "Clio" ? <ClioIcon className="w-10 h-8" /> : Source === "CSV" ? <CsvColorIcon className='w-10 h-8 mr-2' /> : <MicroSoftImportContacts className='w-10 h-10 mr-2' />}
                </div>
                <div className="d-flex justify-center mb-3">
                    <Typography className='h2-semibold'>Records Imported Successfully!</Typography>
                </div>
                {['panel1', 'panel2', 'panel3'].slice(0, Data.Type === ImportType.Contacts ? 3 : 2).map((panel, index, arr) => (
                    <Accordion
                        key={panel}
                        expanded={expanded === panel}
                        onChange={handleChangeAccordion(panel)}
                        disableGutters
                        elevation={0}
                        square
                        sx={{ border: '1px solid rgba(0, 0, 0, .125)', borderLeft: '1px solid rgba(0, 0, 0, .125)', borderRight: '1px solid rgba(0, 0, 0, .125)', borderBottom: index === arr?.length - 1 ? '1px solid rgba(0, 0, 0, .125)' : 'none' }}>
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls={`${panel}bh-content`}
                            id={`${panel}bh-header`}
                            sx={{
                                backgroundColor: 'rgba(0, 0, 0, .03)',
                            }}
                        >
                            <div className="d-flex align-center">
                                <MicrosoftImportContactsBlueTick className="ml-1 mr-2" />
                                <div>{loading ? <AnimateLoader LoaderAnimation={ImportReportLoader} className="w-3 h-3 d-flex align-center" /> : ""}</div>
                                <Typography className='h4-regular'> <span className='h3-bold'>{panel === 'panel1' ? Data.Type === ImportType.Contacts ? recards?.SavedRecords?.length : scheduleReport?.SavedRecords?.length : panel === 'panel2' ? Data.Type === ImportType.Contacts ? recards?.IgnoredRecords?.length : scheduleReport?.IgnoredRecords?.length : recards?.ExistingRecords?.length}</span>{panel === 'panel1' ? ' Record Created' : panel === 'panel2' ? ' Records Skipped' : ' Records Existing'} </Typography>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className="px-0 py-0">
                            <div className="h-v-45">
                                <GridComponent
                                    ColumnDefs={Data.Type === ImportType.Contacts ? ContactsColoumnDefs : ScheduleColoumnDefs}
                                    RowData={getPanelData(panel, Data.Type === ImportType.Contacts ? recards : scheduleReport)}
                                    OnGridReady={GridReady}
                                    IsPaginationEnabled={false}
                                    EmptyLabel={"there are no records available yet!."}
                                    LockVisible={false}
                                    gridApi={gridApi}
                                    isHorizontalScroll={true}
                                />
                            </div>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </DialogContent>
        </Dialog>
    )
}

export default ContactHistoryInfo